// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"Banks_maindiv__2ICm-","heading":"Banks_heading__27Xwa","input_div":"Banks_input_div__ELSjV","bank_input":"Banks_bank_input__sXnYS","bank_list":"Banks_bank_list__Vm5D_"};